module.exports = __webpack_public_path__ + "static/img/ent-6.66cfbb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-6.jpg
// module id = 3Wf5
// module chunks = 51